<template>
    <div>
        <Header>
        </Header>

        <div class="page page--narrow">

            <h3 class="h3" v-t="'Billing History'"></h3>
            <table class="editor-table editor-table--primary">
                <tr>
                    <th v-t="'Date'"></th>
                    <th v-t="'Method'"></th>
                    <th v-t="'Amount'"></th>
                    <th v-t="'View Receipt/Invoice'"></th>
                </tr>
                <tr v-bind:key="row.url" v-for="row in history">
                    <td>{{row.date}}</td>
                    <td>{{row.method}}</td>
                    <td><span v-if="row.method=='Refund'">-</span>
                    {{row.amount}}</td>
                    <td><a target="_blank" v-if="row.url" :href="row.url" v-t="'View'"></a><span v-if="!row.url">-</span></td>
                </tr>
                <tr v-if="history.length==0">
                    <td colspan="2" v-t="'No payments found'"></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'

    export default {
        components: {
            Header
        },
        data () {
            return {
                history: []
            }
        },
        mounted () {
            this.$http.get('/portfolio/billing-history/').then(data => {
                this.history = data.data
            })
        }
    }
</script>